<template>
  <layout-default>
    <v-card>
      <v-toolbar flat color="indigo darken-1" dark>
        <v-card-title> VSTECS Event Management </v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-data-table :headers="headers" :items="Event">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>My Events</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="900px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    New Item
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }} {{ editItem.uuid }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="8">
                          <v-text-field v-model="editedItem.eventname" label="Event name"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-menu ref="xMenu" v-model="xMenu" :close-on-content-click="false" :return-value.sync="editedItem.RegisExpired"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="editedItem.RegisExpired" label="Set Event Expired " prepend-icon="mdi-calendar" readonly 
                                v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="editedItem.RegisExpired" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="xMenu = false">
                                Cancel
                              </v-btn>
                              <v-btn text color="primary" @click="$refs.xMenu.save(editedItem.RegisExpired)">
                                OK
                              </v-btn>
                              
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="editedItem.eventtime" label="Event Time"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-select v-model="editedItem.form" :items="EventType" label="Form Name" />
                        </v-col>
                        
                        <v-col cols="12">
                          <v-textarea v-model="editedItem.descption" />
                        </v-col>

                        <v-col cols="12">
                          <v-row>
                            <v-col cols="10">
                              <v-text-field v-model="editedItem.images.head" clearable label="Head Image" />
                            </v-col>
                            <v-col cols="1">
                              <v-file-input hide-input show-size prepend-icon="mdi-cloud-upload" truncate-length="15"
                                v-model="headimg"></v-file-input>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="10">
                              <v-text-field v-model="editedItem.images.edm" clearable label="Edm Part" />
                            </v-col>
                            <v-col cols="1">
                              <v-file-input hide-input show-size prepend-icon="mdi-cloud-upload" v-model="edmimg"
                                truncate-length="15"></v-file-input></v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="510px">
                <v-card>
                  <v-card-title class="text-h5">Are you sure you want to delete this event?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.RegisExpired`]="{ item }">
            {{ item.RegisExpired|xmoment }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
            <v-icon small @click="view(item)"> mdi-file-document </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="init"> Reset </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-overlay :opacity="0.4" :value="onload">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
  </layout-default>
</template>
<script>
import { msalMixin } from "vue-msal";
import layoutDefault from "@/layouts/backend.vue";
import moment from "moment";

import { v1 as uuidv1 } from "uuid";

const API = process.env.VUE_APP_API;

const v1options = {
  node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
  clockseq: 0x1234,
  msecs: new Date().getTime(),
  nsecs: 5678,
};

export default {
  name: "AdminHome",
  mixins: [msalMixin],
  components: {
    layoutDefault,
  },

  filters: {
    xmoment: function (xdate) {
      if (xdate)
        return moment(xdate).format("DD MMM YYYY");
      else return 'No Expire'
    },
  },
  data: () => ({
    xdate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    xMenu: false,
    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    EventType: ["Seminar/Company Event", "Special Events", "Trip"],
    headimg: null,
    edmimg: null,
    editedItem: {
      uuid: "",
      language: "",
      eventname: "",
      eventtime: "",
      descption: "",
      RegisExpired: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      form: "",
      images: {
        head: "",
        edm: "",
      },
    },
    defaultItem: {
      uuid: uuidv1(v1options),
      language: "Thailand",
      eventname: "",
      eventtime: "",
      descption: "",
      form: "",
      RegisExpired:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      images: {
        head: "",
        edm: "",
      },
    },
    Event: [],
    headers: [
      {
        text: "Eventname",
        sortable: false,
        width: "30%",
        value: "eventname",
      },
      {
        text: "Event Time",
        sortable: false,
        value: "eventtime",
        width: "30%",
      },
      {
        text: "Type",
        sortable: false,
        value: "form",
        width: "20%",
      },
      {
        text: "Expired",
        sortable: false,
        value: "RegisExpired",
        width: "10%",
      },
      {
        text: "Actions",
        value: "actions",
        width: "15%",
        sortable: false,
        align: "end",
      },
    ],
    onload: false,
  }),
  created() {
    this.init();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  methods: {
    async init() {
      this.Event = await this.getEvent();
    },
    async getEvent() {
      this.onload = true;
      try {
        let rest = await axios.get(`${API}/event`);
        this.onload = false;
        return rest.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    editItem(item) {
      this.editedIndex = this.Event.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.Event.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      let x = await axios.delete(`${API}/event/${this.editedItem.uuid}/delete`);
      if (x.data.massage == "Deactivate") {
        this.Event.splice(this.editedIndex, 1);
      } else {
        alert("Delete Error!!");
      }
      this.Event = await this.getEvent();
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async closeDelete() {
      this.dialogDelete = false;
      this.Event = await this.getEvent();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    view(item) {
      this.$router.push({
        name: "EventAdmin",
        params: { id: item.uuid },
      });
    },
    async save() {
      this.onload = true;
      this.close();
      if (this.editedIndex > -1) {
        try {
          if (!this.editedItem.images.head) this.editedItem.images.head = ""
          if (!this.editedItem.images.edm) this.editedItem.images.edm = ""
          await axios.patch(
            `${API}/event/${this.editedItem.uuid}/edit`,
            this.editedItem
          );
          await this.init();
        } catch (e) {
          alert("Edit Error");
        }
      } else {
        try {
          let x = await axios.post(`${API}/event/new`, this.editedItem);
          this.Event.push(x);
        } catch (e) {
          alert("Add Item Error");
        }
      }
      this.Event = await this.getEvent();
    },
    async headimgload(e) {
      this.editedItem.images.head = e.target.result;
      // console.log(await e.target.result)
    },
    async edmimgload(e) {
      this.editedItem.images.edm = e.target.result;
      // console.log(await e.target.result)
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    headimg(val) {
      var reader = new FileReader();
      reader.onload = (e) => this.headimgload(e);
      reader.readAsDataURL(val);
      // reader.readAsArrayBuffer(val);
    },
    edmimg(val) {
      var reader = new FileReader();
      reader.onload = (e) => this.edmimgload(e);
      reader.readAsDataURL(val);
    },
  },
};
</script>
